import React from 'react';

import {
  Flex,
  Modal, ModalCloseButton, ModalContent, ModalOverlay, Text,
} from '@chakra-ui/react';

import { StatusBadge } from 'components';
import SectionContent from 'containers/Section/Content';

export default function Dispatch({
  isOpen, onClose, data, refetch, isFetching,
}: any) {
  if (!data) {
    return null;
  }

  return (
    <Modal
      size="2xl"
      isOpen={isOpen}
      onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        alignSelf="center"
        alignItems="center">
        <Flex
          p={2}
          borderBottom="1px"
          borderColor="gray.300"
          width="100%"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between">
          <Text
            variant="mediumBold"
            color="primary.default">Despacho
          </Text>
          <StatusBadge
            mr={10}
            label={data.status.toLocaleUpperCase()}
            iconName="clock"
            status={data.status}
          />
          <ModalCloseButton top={1} />
        </Flex>
        <Flex
          alignItems="center"
          justifyContent="center"
          p={6}
          width="100%">
          <SectionContent
            data={data}
            isFetching={isFetching}
            isExecution
            onSuccess={refetch}
          />
        </Flex>
      </ModalContent>
    </Modal>
  );
}
